import { useQuery } from "@tanstack/react-query";

import { getLoadApiReference, getLoadDictionary, getManifestDictionary } from "@/api/integration";

/** O dicionário da API de carga (#1782): muda só com deploy, então fica em cache por mais tempo. */
export function useLoadDictionary() {
  return useQuery({
    queryKey: ["integration", "dictionary"],
    queryFn: getLoadDictionary,
    staleTime: 10 * 60 * 1000,
  });
}

/** A referência das rotas de carga, recortada do OpenAPI da api (#1782). */
export function useLoadApiReference() {
  return useQuery({
    queryKey: ["integration", "api-reference"],
    queryFn: getLoadApiReference,
    staleTime: 10 * 60 * 1000,
  });
}

/** Os blocos do manifesto vigente (#1782), do esquema que a api gera. */
export function useManifestDictionary() {
  return useQuery({
    queryKey: ["integration", "manifest"],
    queryFn: getManifestDictionary,
    staleTime: 10 * 60 * 1000,
  });
}
